import { render, staticRenderFns } from "./RequestPasswordReset.vue?vue&type=template&id=650dcd68"
import script from "./RequestPasswordReset.vue?vue&type=script&lang=ts"
export * from "./RequestPasswordReset.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports